<template>
    <div>
        <div class="block-list" >
            <div class="block-item" v-for="(block, index) in blocksOrdered">
                <component :name="block.name" v-bind:is="block.type" :input="block"></component>
            </div>
        </div>
    </div>
</template>

<script>
    import Ckeditor from "../ckeditor/ckeditor";

    export default {
        name: "proposal",
        props: {
            proposals: { default: ''},
            invoice_id: { default: '' },
        },
        computed: {
            blocksOrdered: function () {
                return this.blocks.where('type', '!=', 'coverBlock').sortBy('sort_order').toArray();
            }
        },
        data() {
            return {
                blocks: window.collect([])
            }
        },
        created() {
            this.blocks = window.collect(this.proposals);
            this.fixSort();
            this.$eventHub.$on('updateBlock', this.updateBlock);
            this.$eventHub.$on('updateSort', this.updateSort);
        },
        methods: {
            updateBlock(key, value) {
                this.$set(this.blocks, key, value);
            },
            updateSort(id, direction) {
                var toChange = this.blocks.where('public_id','=', id).first();
                var lastNo = this.blocks.count();
                var sortOrderNo = toChange.sort_order;
                if ((toChange.sort_order === 1 && direction === 'up') ||
                    (toChange.sort_order === lastNo && direction === 'down')) {
                    return;
                }
                var blocksToChange = [];
                this.blocks.transform((item) => {
                    if ((item === toChange && direction === 'down') ||
                        (direction === 'up' && (sortOrderNo - 1) === item.sort_order) ) {
                        // Sort Order moves up
                        item.sort_order++;
                        blocksToChange.push(item);
                    } else if ((item === toChange && direction === 'up') ||
                        (direction === 'down' && (sortOrderNo + 1) === item.sort_order) ) {
                        // Sort Order goes down
                        item.sort_order--;
                        blocksToChange.push(item);
                    }
                    return item;
                });
                this.submitSort(blocksToChange);
            },
            fixSort()
            {
                var i = 0;
                var toFix = [];
                this.blocks.each((block) => {
                    i++;
                    if (block.sort_order !== i) {
                        block.sort_order = i;
                        toFix.push(block);
                    }
                });
                this.submitSort(toFix);
            },
            submitSort(data)
            {
                if (data.length === 0) return;
                this.axios.post('/api/proposal/sort', { blocks: data }).then(() => {});
            },
            onUpdate(event){

            }
        },
        components: {
            'htmlBlock': require('../proposal/htmlBlock.vue').default,
        },
    }
</script>

<style scoped>

</style>